import { render, staticRenderFns } from "./Nodata.vue?vue&type=template&id=5c1605d9&scoped=true"
import script from "./Nodata.vue?vue&type=script&lang=js"
export * from "./Nodata.vue?vue&type=script&lang=js"
import style0 from "./Nodata.vue?vue&type=style&index=0&id=5c1605d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1605d9",
  null
  
)

export default component.exports